import { $AssetModel } from "@atlassiansox/bxp-content-framework";

import { Video } from "../../components";
import { UiVideoModel } from "../../models";

export type UiVideoProps = {
    readonly model: UiVideoModel;
};

const UiVideo = ({ model }: UiVideoProps) => {
    //get boolean model props
    const { autoplay, loop, controls, muted } = model.content;

    //simplify sources
    const sources = model.content.sources?.map((source) => source.url);

    //return video tag
    return (
        <Video
            data-testid="ui-video"
            {...getPosterProps(model.content.poster)}
            {...{ loop, controls, muted, autoplay, sources }}
        >
            {model.content.title}
        </Video>
    );
};

type PosterProps = { poster?: string; width?: number; height?: number };

//get video poster, width, and height props from optionally-linked image asset
function getPosterProps(poster?: $AssetModel): PosterProps {
    const props: PosterProps = {};
    if (poster) {
        props.poster = poster.url;
        if (poster.width) props.width = poster.width;
        if (poster.height) props.height = poster.height;
    }
    return props;
}

export default UiVideo;
